import { Api, IDeserialize, IWebApplication, Listeners, Routing, WebApplication, setLocation } from "@timesheets/webapp-support";
import { Contact, RectangularName, SaveTrees, SquareName } from "@timesheets/constants-common";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { PageTypes, router } from "@/routing";
import { Route, browserPolyfills } from "@gemma/utils";

import BootstrapVue from "bootstrap-vue";
import Breakpoints from "breakpoints-js";
import { Contact as ContactEvents } from "@gemma/entities";
import { IEvent } from "@gemma/events";
import { IState } from "../vuex/IState";
import IconedInput from "Components/IconedInput/Index.vue";
import { Id } from "@gemma/typescript-types";
import { Store } from "vuex";
import { TRouteMetaGroup } from "../routing/TRouteMetaGroup";
import { TRoutes } from "./TRoutes";
import { TimesheetsWireSerializer } from "@timesheets/common";
import { User } from "../vuex/modules/user/User";
import { Plugin as VsNotifyPlugin } from "../plugins/notify";
import Vue from "vue";
import VueRouter from "vue-router";
// @ts-ignore
import { Plugin as VueSubmitPlugin } from "vue-submit/src/library.js";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { getStore } from "../vuex/getStore";
import { handlePages } from "../routing/handlePages";
import { hotjar } from "@/utils";

export async function initialize(
  pageType: PageTypes,
  routes: TRoutes
): Promise<
  | {
      router: VueRouter;
      store: Store<IState>;
      webApplication: IWebApplication<Route<TRouteMetaGroup>>;
    }
  | false
> {
  const timesheetsWireSerializer = new TimesheetsWireSerializer();
  const store = getStore();
  store.dispatch("updateLogoTimestamp", { logoType: SquareName, tenantName: SaveTrees.ReservedNames[0] });
  store.dispatch("updateLogoTimestamp", { logoType: RectangularName, tenantName: SaveTrees.ReservedNames[0] });

  const api = new Api(WebApplicationConstants, timesheetsWireSerializer as IDeserialize);
  const user = new User(store);
  const webApplication = new WebApplication(api, WebApplicationConstants, timesheetsWireSerializer, user);
  await store.dispatch("loadCurrentSession", webApplication);
  store.dispatch("updateLogoTimestamp", { logoType: SquareName, tenantName: store.state.currentSession.branding.names.currentCanonical });
  store.dispatch("updateLogoTimestamp", { logoType: RectangularName, tenantName: store.state.currentSession.branding.names.currentCanonical });
  if (store.state.currentSession.account.isLoggedIn) {
    await store.dispatch("user/loadProfile", { webApplication });
  }

  const resolveCorrectPage = handlePages(pageType, store, (routeResult: Routing.RouteResult<{ group: string }>) => {
    setLocation(routeResult, {
      onNoLocation: () => routeResult.route && window.location.assign(routeResult.route.fullPath),
    });

    return routeResult;
  });

  const routeResult = resolveCorrectPage(window.location.href, new Route(window.location.pathname));
  if (!routeResult.continue) {
    return false;
  }

  const _routes = routes(api, store);
  const _router = router(pageType, store, _routes);
  api.setRouter(_router);

  hotjar(WebApplicationConstants.instance, WebApplicationConstants.defaultLogger);
  browserPolyfills();
  Breakpoints(WebApplicationConstants.responsiveBreakpoints);

  Listeners.setupListeners(webApplication);

  Vue.use(BootstrapVue);
  Vue.use(VueSubmitPlugin);
  Vue.use(VsNotifyPlugin);

  Vue.component("FontAwesomeIcon", FontAwesomeIcon);
  Vue.component("FontAwesomeLayers", FontAwesomeLayers);
  Vue.component("IconedInput", IconedInput);

  WebApplicationConstants.eventBus.createFilter(Contact.SetContactDetails).addSubscription(
    async (event: IEvent<Id & { details: ContactEvents.Events.SetContactDetails.ISetContactDetailsEventData }, string>) => {
      const currentSession = await api.getCurrentSession();
      if (((event.data as unknown) as { account: Id }).account.id === currentSession.account.id) {
        await store.dispatch("setCurrentSessionProperties", { isEnabled: event.data.details.enabled, emailAddress: event.data.details.emailAddress, fullname: event.data.details.fullname });
      }
    },
    "updateSessionAccount",
    WebApplicationConstants
  );

  return { store, router: _router as VueRouter, webApplication };
}
